import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" {...props}>
    <path
      fill="currentColor"
      d="M9.616.616a1.25 1.25 0 0 1 1.768 1.768l-6 6a1.25 1.25 0 0 1-1.768 0l-3-3a1.25 1.25 0 0 1 1.768-1.768L4.5 5.733 9.616.616Z"
    />
  </svg>
);
export const CheckToggleIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
